<template>
  <div id="settlement">
    <custom-table
      ref="customTable"
      has-organization="true"
      :customOptions="customOptions"
      :columns="columns"
      excel-type="AirportAccountFinanceFlowing"
    >
      <div slot="customTable-top" style="padding-bottom: 16px">
        <el-radio-group v-model="status" @change="statusChange">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button
            :label="item.value"
            v-for="item in $const.SETTLEAUDITSTATUS"
            :key="item.value"
          >
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <template slot="search-bottom">
        <div class="tipInfo">结算时请确认出资账户余额充足，若因出资账户余额不足导致的转账失败可重新发起转账</div>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="105px">
          <div slot-scope="{ row }" class="custom-action">
            <!-- <el-tooltip :content="row.withdrawalStatus==3?'重新转账':'通过'" placement="top" v-if="row.withdrawalStatus !== 2 || row.status !==2"> -->
            <!-- <i class="iconfont icon-pass" @click="passClick(row)"></i> -->
            <el-button
              v-if="row.withdrawalStatus !== 2 || row.status !== 2"
              type="text"
              size="mini"
              @click="passClick(row)"
              >{{ row.withdrawalStatus == 3 ? "重新转账" : "通过" }}</el-button
            >
            <!-- </el-tooltip> -->
            <span v-else>-</span>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime }}</template>
        <template v-else-if="item.prop === 'updated'">
          <span v-if="row.status === 2">{{ row.updated | filterTime }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'status'">
          <el-tag size="small" :type="row.status | filterConst('SETTLEAUDITSTATUS', 'type')">{{ row.status | filterConst('SETTLEAUDITSTATUS') }}</el-tag>
        </template>
        <template v-else-if="item.prop === 'withdrawalStatus'">
          <span v-if="row.withdrawalStatus == 2"> 转账成功 </span>
          <span v-else-if="row.withdrawalStatus == 3">
            转账失败
            <el-tooltip
              v-if="row.withdrawalStatus === 3"
              class="item"
              effect="dark"
              :content="row.withdrawalFailReason"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <span v-else-if="row.withdrawalStatus == 1">转账中</span>
        </template>
        <template v-else-if="item.prop === 'fee'">
          <span class="util-money" v-if="row.fee || row.fee === 0">{{
            row.fee
          }}</span>
          <span v-if="!row.fee && row.fee !== 0">-</span>
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
    </custom-table>

    <!-- <el-dialog
      :visible.sync="show"
      destroy-on-close
      title="审核设置"
      width="600px"
      :before-close="() => (show = false)"
    >
      <settlementSetting
        @handClose="show = false"
        v-if="show"
      ></settlementSetting>
    </el-dialog> -->
  </div>
</template>

<script>
// import settlementSetting from "./components/settlementSetting.vue";

export default {
  name: "settlement",
  // components: { settlementSetting },
  data() {
    return {
      // 结算审核状态
      status: "",
      show: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/airport/account/flowing/settlement",
        params: {
          status: this.status,
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "name",
            name: "申请人",
            value: "",
          },
          {
            type: "input",
            field: "phone",
            name: "手机号",
            value: "",
          },
          {
            type: "select",
            field: "withdrawalStatus",
            name: "转账状态",
            value: "",
            option: this.$const.TRANSFERFAILREASON,
          },
          {
            type: "datetime",
            field: "created",
            dateProp: {
              // 类型为datetime配置搜索字段使用，默认是 startTime 和 endTime
              start: "applyTimeStart",
              end: "applyTimeEnd",
            },
            name: "申请时间",
            value: [],
          },
        ],
      },
      // 表头
      columns: [
        { prop: "name", label: "申请人" },
        { prop: "phone", label: "手机号码" },
        { prop: "fee", label: "申请结算金额" },
        { prop: "created", label: "申请时间" },
        { prop: "updated", label: "处理时间" },
        { prop: "status", label: "审核状态" },
        { prop: "withdrawalStatus", label: "转账状态" },
      ],
    };
  },
  created() {
    if (this.$route.query.status) {
      this.status = this.$route.query.status;
      this.customOptions.params.status = this.status;
    }
  },
  methods: {
    handClose() {
      this.rowData = {};
      this.show = false;
      this.showCancel = false;
      this.$refs.customTable.listFn();
    },
    actionFn({ type, row }) {
      switch (type) {
        case "add":
          this.show = true;
          break;
      }
    },
    /**
     * 状态改变
     */
    statusChange() {
      this.customOptions.params.page = 1;
      this.customOptions.params.status = this.status;
      this.$refs.customTable.listFn();
    },
    /**
     * 通过
     */
    async passClick(row) {
      const tipText = row.withdrawalStatus == 3 ? "重新转账" : "通过";
      this.$confirm(`确认${tipText}吗?`, `${tipText}提示`).then(async () => {
        let url = "/api/v1/manage/airport/account/flowing/settlement";
        let params = {
          accountId: row.accountId,
          id: row.id,
        };
        let data = await this.$axios.put(url, params);
        if (data && data.code === 1) {
          this.$message.success("操作成功！");
        }
        this.$refs.customTable.listFn();
      });
    },
  },
};
</script>

<style lang="less">
</style>
